/**
 * PODZ-1830 / D-CAP-SOURCE-MAP — single source→label mapping for the media
 * upload-meta footer. Both lightboxes (photo + video) consume this one helper
 * so the footer renders identically and the omission rule lives in one place.
 *
 * Only the three product-facing sources carry a label. Every other value —
 * including the real backend enum `widget`, unknown values, and absent/empty
 * source — intentionally returns undefined so the footer omits the segment.
 * The lookup is read-only against a fixed allowlist Record: an untrusted enum
 * string is used purely as a key, so an unmapped/malicious value simply yields
 * undefined (no prototype-pollution risk, T-07.1-02 accepted).
 */
export const SOURCE_LABELS: Record<string, string> = {
  tech_app: 'Tech App',
  admin_portal: 'Office/Admin',
  customer_portal: 'Customer Portal',
};

/**
 * Map a media `source` enum to its human footer label, or undefined when the
 * source is absent/empty or has no product label (widget/unknown). Undefined
 * means "omit the footer source segment".
 */
export function sourceLabel(s?: string): string | undefined {
  return s ? SOURCE_LABELS[s] : undefined;
}
